module.exports = __webpack_public_path__ + "img/auditLogo.134f77b8.png";